import React from 'react'
import FooterCard from './FooterCard';
import FooterBottom from './FooterBottom';
import { Link } from 'react-router-dom';
import logoWhite from '../assets/ep_logo_white.png'
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

export default function Footer() {
    let brandName = process.env.REACT_APP_COMPANY_N

    brandName = 'SURYA JYOTI LEASING AND FINANCE LIMITED';
    // const brandLogo = process.env.REACT_APP_LOGO
    return (
        <>
            <div className='footer-section-bottom text-white pt-5' style={{ background: '#000' }}>
                <div className='container'>
                    <div className='row mt-4 pb-5 footer'>
                        <div className='col-lg-4'>
                            {/* <Link to='/'><img src={logoWhite} alt={brandName} width={"100px"} /></Link> */}
                            <p className='text-white mt-3'>Welcome to {brandName}, Signup For Our Latest news & Article. We Won't give you spam mail and irrevelevnt messages.</p>

                            <Link to='https://www.facebook.com/snaprupee' target='_blank' color='#fff' aria-label="facebook" >
                                <FacebookIcon size={50} className='socilthum' />
                            </Link>
                            <Link to='https://www.youtube.com/@SnapRupee ' target='_blank' aria-label="Youtube" ><YouTubeIcon size={50} className='socilthum' /></Link>
                            <Link to='https://www.linkedin.com/company/snaprupee/about/' target='_blank' aria-label="LinkedIn"><LinkedInIcon size={50} className='socilthum' /></Link>
                            <Link to='https://www.instagram.com/snaprupee/' target='_blank' aria-label="Instagram"><InstagramIcon size={50} className='socilthum' /></Link>
                        </div>
                        <div className='col-lg-3'>
                            <h4 >Our Services</h4>
                            <ul className='link-text'>
                                <li> <Link to='/short-term-loan'>  <KeyboardArrowLeftIcon />Short Term Loan  </Link></li>
                                <li><Link to='/instant-personal-loan'> <KeyboardArrowLeftIcon />Instant Personal Loan  </Link></li>
                                <li><Link to='/emergency-loan'> <KeyboardArrowLeftIcon />SnapRupee  Loan   </Link></li>

                            </ul>
                        </div>
                        <div className='col-lg-2'>
                            <h4>Quick Link</h4>
                            <ul className='link-text'>
                                <li>
                                    <Link to='/about'> <KeyboardArrowLeftIcon />About</Link>
                                </li>
                                <li>
                                    <Link to='/contact'> <KeyboardArrowLeftIcon />Contact Us</Link>
                                </li>
                                <li>
                                    <Link to='/privacy-policy'> <KeyboardArrowLeftIcon />Privacy Policy</Link>
                                </li>
                                <li>
                                    <Link to='/terms-and-conditions'>Terms and Conditions</Link>
                                </li>
                               
                                <li>
                                    <Link to='/repay-loan'><KeyboardArrowLeftIcon />Pay Now </Link>
                                </li>
                                <li>
                                    <Link to='/apply-now'>  <KeyboardArrowLeftIcon />Apply Now </Link>
                                </li>
                                {/* <li>
                                    <Link to='/rate-and-terms'> <KeyboardArrowLeftIcon />Rate and Terms </Link>
                                </li> */}
                            </ul>
                        </div>
                        <div className='col-lg-3'>
                            <h4>Contact Us</h4>
                             <FooterCard static="24/7 Our Location"  val="407-408, B-08, ITL Tower, Netaji Subhash Place, Pitampura, New Delhi, Delhi 110034" />

                          
                            <a href="mailto: info@snaprupee.in" style={{ color: '#fff',textDecoration:'none' }}>
                                <FooterCard  val="info@snaprupee.in"   /></a>
                                

                           
                        </div>
                    </div>
                </div>
            </div>
            <FooterBottom />
        </>
    )
}
